export default "__VITE_ASSET__259cf216__"